module.exports = __webpack_public_path__ + "assets/img/favicon.b049fa1f.png";